import crudActions from '../../crud/actions'

const actions = crudActions('SERVICEUSER_CONDITION_')

export default actions
